import { render } from "./PurchaseGuide.vue?vue&type=template&id=16cd6184"
import script from "./PurchaseGuide.vue?vue&type=script&lang=js"
export * from "./PurchaseGuide.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__